/**
 * Defines the Cell Type Separator, that draws a blue background
 */
export const CELL_TYPE_SEPARATOR = 'separator';
/**
 * Const to determinate when the a row was selected
 */
export const SELECTED_RULE_ROW_EVENT = 'selectedRuleRowEvent';

export class PTableCompGrid1004And2055 {

	constructor() {
		// silent is gold
	}

	public static sections = [
		{
            key:'photo',
			headerName: 'Photo',
			subjectPath: '',
			compPath: []
		},
		{
            key: 'publicRecords',
			headerName: 'Public Records',
			subjectPath: '',
			compPath: []
		},
		{
            key: 'address',
			headerName: 'Address',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectStreetAddress',
			compPath: ['CVLocationPropertyStreetAddress']
		},
		{
            key: 'city',
			headerName: 'City',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectCity',
			compPath: ['CVLocationPropertyCity']
		},
		{
            key: 'county',
			headerName: 'County',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectCounty',
			compPath: ['CVLocationPropertyCounty']
		},
		{
            key: 'state',
			headerName: 'State',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectState',
			compPath: ['CVLocationPropertyState']
		},
		{
            key: 'zip',
			headerName: 'Zip',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.CVSubjectPostalCode',
			compPath: ['CVLocationPropertyPostalCode']
		},
		{
            key: 'general',
			type: CELL_TYPE_SEPARATOR,
			headerName: 'General'
		},
		{
            key: 'distanceFromSubjectInMiles',
			headerName: 'Distance from subject (miles)',
			subjectPath: '',
			compPath: ['CVLocationProximityToSubject']
		},
		{
            key: 'salePrice',
			type: CELL_TYPE_SEPARATOR,
			headerName: 'Sale Price'
		},
		{
            key: 'amount',
			headerName: 'Amount',
			subjectPath: '',
			compPath: ['CVPropertySalesAmount'],
			type: 'money'
		},
		{
            key: 'ppsfSalePriceSlashGrossLivingAreaAmount',
			headerName: 'PPSF (Sale Price/GLA)',
			subjectPath: '',
			compPath: ['CVSalesPricePerGrossLivingAreaAmount'],
			type: 'money'
		},
		{
            key: 'dataSources',
			headerName: 'Data Source(s)',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'source',
			headerName: 'Source',
			subjectPath: '',
			compPath: ['CVDataSource']
		},
		{
            key: 'mlsName',
			headerName: 'MLS Name',
			subjectPath: '',
			compPath: ['CVDataSourceMlsName']
		},
		{
            key: 'mlsNumber',
			headerName: 'MLS Number',
			subjectPath: '',
			compPath: ['CVDataSourceMlsNumber']
		},
		{
            key: 'verificationSources',
			headerName: 'Verification Source(s)',
			subjectPath: '',
			compPath: ['CVDataSourceVerificationDescription']
		},
		{
            key: 'saleSlashFinancingConcessions',
			type: CELL_TYPE_SEPARATOR,
			headerName: 'Sale/Financing Concessions'
		},
		{
            key: 'saleType',
			headerName: 'Sale Type',
			subjectPath: '',
			compPath: ['CVSaleType', 'CVSaleTypeAdjustmentAmount']
		},
		{
            key: 'financingType',
			headerName: 'Financing Type',
			subjectPath: '',
			compPath: ['CVFinancingType']
		},
		{
            key: 'concessionAmount',
			headerName: 'Concession Amount',
			subjectPath: '',
			compPath: ['CVConcessionAmount', 'CVConcessionAdjustmentAmount'],
			type: 'money'
		},
		{
            key: 'dateOfSale',
			type: CELL_TYPE_SEPARATOR,
			headerName: 'Date of sale'
		},
		{
            key: 'status',
			headerName: 'Status',
			subjectPath: '',
			compPath: ['CVListingStatusType']
		},
		{
            key: 'date',
			headerName: 'Date',
			subjectPath: '',
			compPath: ['CVDateOfSale', 'CVDateOfSaleAdjustmentAmount']
		},
		{
            key: 'contractDate',
			headerName: 'Contract Date',
			subjectPath: '',
			compPath: ['CVDateOfContract']
		},
		{
            key: 'daysOnMarket',
			headerName: 'Days on Market',
			subjectPath: '',
			compPath: ['CVDaysOnMarketDescription']
		},
		{
            key: 'location',
			type: CELL_TYPE_SEPARATOR,
			headerName: 'Location'
		},
		{
            key: 'locationRating',
			headerName: 'Location Rating',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVOverallLocationRatingType',
			compPath: ['CVOverallLocationRatingType', 'CVOverallLocationRatingAdjustmentAmount']
		},
		{
            key: 'locationFactorOne',
			headerName: 'Location Factor 1',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVOverallLocationFactor1',
			compPath: ['CVOverallLocationFactor1']
		},
		{
            key: 'locationFactorTwo',
			headerName: 'Location Factor 2',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVOverallLocationFactor2',
			compPath: ['CVOverallLocationFactor2']
		},
		{
            key: 'propertyRights',
			type: CELL_TYPE_SEPARATOR,
			headerName: 'Property Rights'
		},
		{
            key: 'leaseHoldSlashFeeSimple',
			headerName: 'Leasehold / Fee Simple',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVPropertyRights',
			compPath: ['CVPropertyRights', 'CVPropertyRightsAdjustmentAmount']
		},
		{
            key: 'siteSize',
			headerName: 'Site size',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'size',
			headerName: 'Size',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVSiteArea',
			compPath: ['CVSiteArea', 'CVSiteAreaAdjustmentAmount'],
			type: 'terrain',
		},
		{
            key: 'view',
			headerName: 'View',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'viewRating',
			headerName: 'View Rating',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVViewOverallRatingType',
			compPath: ['CVViewOverallRatingType', 'CVViewOverallRatingTypeAdjustmentAmount']
		},
		{
            key: 'viewFactorOne',
			headerName: 'View Factor 1',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVViewFactor1',
			compPath: ['CVViewFactor1']
		},
		{
            key: 'viewFactorTwo',
			headerName: 'View Factor 2',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVViewFactor2',
			compPath: ['CVViewFactor2']
		},
		{
            key: 'design',
			headerName: 'Design',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'designStyle',
			headerName: 'Design Style',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVDesignDescriptionStyle',
			compPath: ['CVDesignDescriptionStyle', 'CVDesignStyleAdjustmentAmount']
		},
		{
            key: 'attachmentType',
			headerName: 'Attachment Type',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVDesignAttachmentType',
			compPath: ['CVDesignAttachmentType']
		},
		{
            key: 'numberOfLevels',
			headerName: 'Number of stories',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVDesignNumberOfStories',
			compPath: ['CVDesignNumberOfStories']
		},
		{
            key: 'structure',
			headerName: 'Structure',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'yearBuilt',
			headerName: 'Year Built',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVStructureYearBuilt',
			compPath: ['CVStructureYearBuilt', 'CVStructureYearBuiltAdjustmentAmount']
		},
		{
            key: 'qualityOfConstruction',
			headerName: 'Quality of Construction',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVStructureQualityOfConstruction',
			compPath: [
				'CVStructureQualityOfConstruction',
				'CVStructureQualityOfConstructionAdjustmentAmount'
			]
		},
		{
            key: 'condition',
			headerName: 'Condition',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVStructureCondition',
			compPath: ['CVStructureCondition', 'CVStructureConditionAdjustmentAmount']
		},
		{
            key: 'aboveGradeRooms',
			type: CELL_TYPE_SEPARATOR,
			headerName: 'Above Grade Rooms'
		},
		{
            key: 'roomCount',
			headerName: 'Room Count',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVAboveGradeRoomCount',
			compPath: ['CVAboveGradeRoomCount']
		},
		{
            key: 'bedroomCount',
			headerName: 'Bedroom Count',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVAboveGradeBedroomCount',
			compPath: ['CVAboveGradeBedroomCount', 'CVAboveGradeBedroomCountAdjustmentAmount']
		},
		{
            key: 'bathroomCount',
			headerName: 'Bathroom Count',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVAboveGradeBathroomCount',
			compPath: ['CVAboveGradeBathroomCount', 'CVAboveGradeBathroomCountAdjustmentAmount']
		},
		{
            key: 'grossLivingArea',
			headerName: 'Gross Living Area',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVAboveGradeGrossLivingArea',
			compPath: ['CVAboveGradeGrossLivingArea', 'CVAboveGradeGrossLivingAreaAdjustmentAmount'],
			type: 'terrain',
		},
		{
            key: 'basement',
            headerName: 'Basement',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'hasBasement',
			headerName: 'Has Basement',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVHasBasement',
			compPath: ['CVHasBasement'],
			type: 'boolean'
		},
		{
            key: 'basementExit',
			headerName: 'Basement Exit',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementExit',
			compPath: ['CVBasementExit']
		},
		{
            key: 'totalSquareFeet',
			headerName: 'Total Square Feet',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVTotalBasementSF',
			compPath: ['CVTotalBasementSF', 'CVTotalBasementSFAdjustmentAmount'],
			type: 'terrain',
		},
		{
            key: 'basementFinish',
			headerName: 'Basement Finish',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'isFinished',
			headerName: 'Is Finished',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementIsFinished',
			compPath: ['CVBasementIsFinished'],
			type: 'boolean'
		},
		{
            key: 'finishedSquareFeet',
			headerName: 'Finished Sq Ft',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementFinishedSqFT',
			compPath: ['CVBasementFinishedSqFT', 'CVBasementFinishedSqFTAdjustmentAmount'],
			type: 'terrain',
		},
		{
            key: 'bedrooms',
			headerName: 'Bedrooms',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementFinishedBedrooms',
			compPath: ['CVBasementFinishedBedrooms']
		},
		{
            key: 'recreationRooms',
			headerName: 'Recreation Rooms',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementRecreationRooms',
			compPath: ['CVBasementRecreationRooms']
		},
		{
            key: 'fullBathrooms',
			headerName: 'Full Bathrooms',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementFinishedFullBathrooms',
			compPath: ['CVBasementFinishedFullBathrooms']
		},
		{
            key: 'halfBathrooms',
			headerName: 'Half Bathrooms',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementFinishedHalfBathrooms',
			compPath: ['CVBasementFinishedHalfBathrooms']
		},
		{
            key: 'otherRooms',
			headerName: 'Other Rooms',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVBasementOtherRooms',
			compPath: ['CVBasementOtherRooms']
		},
		{
            key: 'utility',
			headerName: 'Utility',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'functionalUtility',
			headerName: 'Functional Utility',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVFunctionalUtility',
			compPath: ['CVFunctionalUtility', 'CVFunctionalUtilityAdjustmentAmount']
		},
		{
            key: 'heatingAndCooling',
			headerName: 'Heating / Cooling',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVHeatingCoolingDescription',
			compPath: ['CVHeatingCoolingDescription', 'CVHeatingCoolingAdjustmentAmount']
		},
		{
            key: 'energyEfficientItems',
			headerName: 'Energy Efficient Items',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVEnergyEfficientItemsDescription',
			compPath: ['CVEnergyEfficientItemsDescription', 'CVEnergyEfficientItemsAdjustmentAmount']
		},
		{
            key: 'garage',
			headerName: 'Garage',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'hasGarageCarport',
			headerName: 'Has Garage / Carport',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVCarStorageIndicator',
			compPath: ['CVCarStorageIndicator', 'CVCarStorageAdjustmentAmount']
		},
		{
            key: 'attachedGarageSpaces',
			headerName: 'Attached Garage # Spaces',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVCarStorageAttachedGarageSpaces',
			compPath: ['CVCarStorageAttachedGarageSpaces']
		},
		{
            key: 'detachedGarageSpaces',
			headerName: 'Detached Garage # Spaces',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVCarStorageDeattachedGarageSpaces',
			compPath: ['CVCarStorageDeattachedGarageSpaces']
		},
		{
            key: 'drivewaySpaces',
			headerName: 'Driveway # Spaces',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVCarStorageDrivewaySpaces',
			compPath: ['CVCarStorageDrivewaySpaces']
		},
		{
            key: 'builtInGarageSpaces',
			headerName: 'Built In Garage # Spaces',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVCarStorageBuiltInGarageSpaces',
			compPath: ['CVCarStorageBuiltInGarageSpaces']
		},
		{
            key: 'carportSpaces',
			headerName: 'Carport # Spaces',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVCarStorageCarportSpaces',
			compPath: ['CVCarStorageCarportSpaces']
		},
		{
            key: 'amenities',
            headerName: 'Amenities',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'porchAndPatioAndDeck',
			headerName: 'Porch, Patio & Deck',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVPorchDeckDescription',
			compPath: ['CVPorchDeckDescription', 'CVPorchDeckAdjustmentAmount']
		},
		{
            key: 'firePlace',
			headerName: 'Fireplace',
			subjectPath: 'CV_EXTENSION_SECTION.FIELDS.COMPARABLE[0].CVPropertyExtraFeature1Description',
			compPath: ['CVPropertyExtraFeature1Description', 'CVPropertyExtraFeature1AdjustmentAmount']
		},
		{
            key: 'adjustedPrice',
			headerName: 'Adjusted Price',
			type: CELL_TYPE_SEPARATOR,
		},
		{
            key: 'netAdjustmentTotal',
			headerName: 'Net Adjustment (Total)',
			subjectPath: '',
			compPath: ['CVSalePriceTotalAdjustmentAmount'],
			type: 'money'
		},
		{
            key: 'netAdjustmentPercentage',
			headerName: 'Net Adjustment %',
			subjectPath: '',
			compPath: ['CVSalePriceTotalAdjustmentNetPercent'],
			type: 'percentage'
		},
		{
            key: 'grossAdjustmentPercentage',
			headerName: 'Gross Adjustment %',
			subjectPath: '',
			compPath: ['CVSalesPriceTotalAdjustmentGrossPercent'],
			type: 'percentage'
		},
		{
            key: 'adjustedSalePrice',
			headerName: 'Adjusted Sale Price',
			subjectPath: '',
			compPath: ['CVAdjustedSalesPriceAmount'],
			type: 'money'
		}
	];
}
